import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UrlRequestService } from '../../../cross-team-shared/misc-services/resources/url-request.service';
import { TokenManagementService } from '../../../cross-team-shared/misc-services/token-management.service';
import {
  TrainingTemplateRequest,
  TrainingTemplateRequestObjectless,
  TrainingTemplateResponseObjectless,
} from '../../../team-apis/otterdam/training-template';

@Injectable()
export class TrainingTemplateResource extends UrlRequestService {
  private tokenManagementService = inject(TokenManagementService);

  async updateTrainingTemplateObjectless({
    projectId,
    templateId,
    body,
  }: {
    projectId: number;
    templateId: string;
    body: TrainingTemplateRequestObjectless;
  }) {
    const token = await this.tokenManagementService.getToken('access_token');
    return this.request<TrainingTemplateResponseObjectless>(
      'PATCH',
      trainingTemplatePath(projectId, templateId),
      {
        body,
        headers: { Authorization: 'Bearer ' + token },
      },
    );
  }

  async updateTrainingTemplate({
    projectId,
    templateId,
    body,
  }: {
    projectId: number;
    templateId: string;
    body: TrainingTemplateRequest;
  }) {
    const token = await this.tokenManagementService.getToken('access_token');
    return this.request<void>(
      'PATCH',
      trainingTemplatePath(projectId, templateId),
      {
        body,
        headers: { Authorization: 'Bearer ' + token },
      },
    );
  }
}

export function trainingTemplatePath(projectId: number, templateId: string) {
  return `${environment.taskServiceBaseUrl}/projects/${projectId}/trainingTemplates/${templateId}`;
}
